var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"events"},[_c('h1',{staticClass:"title"},[_vm._v("·大雅乐盟大事记")]),_c('div',{staticClass:"timer"},[_c('img',{attrs:{"src":require("@/assets/images/events.png"),"width":"80%","alt":""}})])])
}]

export { render, staticRenderFns }